import { useEffect } from "react"
import { Spinner } from "react-bootstrap"
import { useNavigate, useSearchParams } from "react-router"
import { useAuth } from "../api/auth/store"

const AuthCallback = () => {
    const [searchParams, _] = useSearchParams()
    const navigate = useNavigate()
    const { authorize, loading } = useAuth( state => state)
    const code =  searchParams.get("code")!
    const company =  searchParams.get("com")!
    useEffect( () => {
        if (code !== "" && company !== undefined) {
            authorize(code,company).then( res => {
                navigate("/")
            })
        } else {
            console.error("Invalid callback parameters: code or company is missing.")
        }
    }, [])

    return <>
        <Spinner />
    </>
}

export default AuthCallback